module.exports = __webpack_public_path__ + "static/media/boye.29bb7306.png";